export enum HttpStatusCode {
  noContent = 204,
  unathorized = 401,
  success = 200,
  error = 400,
  accepted = 202
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type IHttpResponse<T = unknown> = {
  statusCode: HttpStatusCode;
  body?: T;
  headers?: Record<string, unknown>;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface IHttpPostParams<T = any> {
  url: string;
  body?: T | T[];
  config?: Record<string, unknown>;
}

export interface IHttpGetParams {
  url: string;
  queryParams?: unknown;
  config?: Record<string, unknown>;
}

export interface IHttpDeleteParams {
  url: string;
  body?: Record<string, unknown>;
  params?: unknown;
}

export interface IHttpPutParams {
  url: string;
  body?: Record<string, unknown>;
}

export interface IHttpPatchParams {
  url: string;
  body?: Record<string, unknown>;
  config?: Record<string, unknown>;
}

export interface IHttpPost {
  post<T>(params: IHttpPostParams): Promise<IHttpResponse<T>>;
}

export interface IHttpGet {
  get<T>(params: IHttpGetParams): Promise<IHttpResponse<T>>;
}

export interface IHttpDelete {
  delete<T>(params: IHttpDeleteParams): Promise<IHttpResponse<T>>;
}

export interface IHttpPut {
  put<T>(params: IHttpPutParams): Promise<IHttpResponse<T>>;
}

export interface IHttpPatch {
  patch<T>(params: IHttpPatchParams): Promise<IHttpResponse<T>>;
}

export type HttpClient = IHttpDelete &
  IHttpGet &
  IHttpPut &
  IHttpPost &
  IHttpPatch;

export const F360HttpClient = Symbol("client");
export const F360HttpClientHorizons = Symbol("clientHorizons");
export const F360HttpClientIndicadores = Symbol("clientIndicadores");
export const F360HttpPesquisa = Symbol("pesquisa");
export const F360HttpClientGitHub = Symbol("clientGitHub");
export const F360GitHubHttpGateway = Symbol("GitHubHttpGateway");
export const F360HttpClientFinancasApi = Symbol("clientFinancasApi");

export interface IHttpMiddlewareIntercept {
  sendFinancasToken(): Promise<void>;
}

export enum EHttpEvent {
  unauthorized = "unauthorized"
}
